import React, { useEffect } from "react";
import { Container } from "react-bootstrap";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import "./CategoryPage.css";
import { useTranslation } from "react-i18next";
import { fetchHeaderContent } from "../../seoroute/redux/actions";
import arrow_left from "../../../assets/arrow_left.svg";
import CategorycardPage from "../../comman/components/CategorycardPage";

function CategoryPage(props) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  let goods_card = {
    minHeight: "380px",
  }

  let service_card = {
    minHeight:"0px",
  }

  useEffect(() => {
    callSetHeadertitle();
    // eslint-disable-next-line
  }, [props?.language]);

  const callSetHeadertitle = () => {
    props?.storetype === "goods"
      ? props?.fetchHeaderContent(t("pages.Goods"), "", "")
      : props?.fetchHeaderContent(t("pages.Service"), "", "");
  };

  return (
    <>
      <div className="category">
        <div className="category_content">
          <Container className="container-md category_container">
            <div className="mb-2 d-flex align-items-center">
              <button onClick={() => navigate("../")} className="icon_btn me-2">
                <img src={arrow_left} alt={"left"}></img>
              </button>
              <h5 className="back-text"> {t("pages.back")}</h5>
            </div>
            <div className="row catalog_list mb-3 ms-0 me-0">
              {props?.storetype !== "" &&
                props?.categories?.map(
                  (item) =>
                    props?.storetype === item?.type && (
                      <CategorycardPage card_style={item?.type==="goods"?goods_card:service_card} item={item} type={item?.type}/>
                     )
                )}
            </div>
          </Container>
        </div>
      </div>
    </>
  );
}

const mapStateToProps = (state) => ({
  language: state?.languageState?.language,
  storetype: state?.home?.storetype,
  categories: state?.home.categories,
});

export default connect(mapStateToProps, {
  fetchHeaderContent,
})(CategoryPage);
